import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ActionSeverity, capturePageAction } from '@chegg/observability';
import { isWindowDefined, getUserUuid } from '@chegg/utils';
import { APOLLO_ERROR_LINK } from '../constants';
export var handleApolloError = function handleApolloError(_ref) {
  var graphQLErrors = _ref.graphQLErrors,
    networkError = _ref.networkError,
    operation = _ref.operation,
    forward = _ref.forward;
  var operationName = operation.operationName,
    getContext = operation.getContext;
  var networkErrorCode = networkError && 'statusCode' in networkError ? networkError.statusCode : '';
  var context = getContext();
  try {
    var customAttributes = {};
    customAttributes.graphQLErrors = JSON.stringify(graphQLErrors);
    customAttributes.networkError = String(networkError);
    capturePageAction({
      action: "[Commerce Error] ".concat(operationName),
      location: "".concat(APOLLO_ERROR_LINK, " (").concat(operationName, ")"),
      severity: ActionSeverity.WARNING
    }, _objectSpread(_objectSpread({}, customAttributes), {}, {
      networkErrorStatusCode: networkErrorCode,
      apolloError: operationName,
      variables: JSON.stringify(operation.variables),
      userUUID: context.headers['x-chegg-user-uuid'] || isWindowDefined && getUserUuid() || 'unknown',
      pageUrl: context.headers['x-chegg-page-url'] || isWindowDefined && window.location.href || 'unknown'
    }));
  } catch (e) {
    // Ignore if object has BigInt or circular references
  }
  return forward(operation);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/links/errorLink.js
// module id = 4116
// module chunks = 11